export default "__VITE_ASSET__BRYKGpju__"